import { render, staticRenderFns } from "./binding-record.vue?vue&type=template&id=2634cc48&"
import script from "./binding-record.vue?vue&type=script&lang=js&"
export * from "./binding-record.vue?vue&type=script&lang=js&"
import style0 from "./binding-record.vue?vue&type=style&index=0&id=2634cc48&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports